export const getEnabledNavOrder = (pagesList) =>
  pagesList.filter((page) => page.enabled);

export const toGroupKey = (name) =>
  name.trim().toLowerCase().replace(/\s+/g, "_");

export const buildConfigItems = (
  order,
  pagesList,
  customPagesList,
  navGroupsList,
) => {
  const enabledKeys = new Set(order.map((item) => item.key));
  const disabledItems = [
    ...pagesList,
    ...customPagesList,
    ...navGroupsList,
  ].filter((item) => !enabledKeys.has(item.key));

  return [...order, ...disabledItems];
};

export const buildPageGroupFromSelection = (
  name,
  iconId,
  pageIds,
  enabled,
  pagesList,
  customPagesList,
) => {
  const selectedPages = pagesList.filter((page) => pageIds.includes(page.key));
  const selectedCustomPages = customPagesList.filter((page) =>
    pageIds.includes(page.key),
  );
  const trimmedName = name.trim();

  return {
    key: toGroupKey(name),
    name: trimmedName,
    icon: iconId,
    type: "group",
    enabled,
    items: [
      ...selectedPages.map((page) => ({
        key: page.key,
        label: page.label,
        enabled: page.enabled,
        type: "page",
      })),
      ...selectedCustomPages.map((page) => ({
        key: page.key,
        label: page.label,
        enabled: page.enabled,
        type: "customPage",
      })),
    ],
  };
};

export const parseNavConfigItems = (items = []) => ({
  pages: items.filter((item) => item.type === "page"),
  customPages: items.filter((item) => item.type === "customPage"),
  navGroups: items.filter((item) => item.type === "group"),
  navOrder: getEnabledNavOrder(items),
});
